import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { EventqActionableList } from '../actionable-list/actionable-list';
import type { EventqActionableListItem } from '../actionable-list/actionable-list.types';
import {
  EventqDialogPopover,
  EventqDialogPopoverPlacement,
} from '../dialog-popover/dialog-popover';
import {
  ACTIVATE_TALKDOWN_OPTIONS,
  ActivateTalkdownConfirm,
  ActivateTalkdownOption,
  ActivateTalkdownOptionId,
} from './activate-talkdown-popover.types';

export type {
  ActivateTalkdownConfirm,
  ActivateTalkdownOption,
  ActivateTalkdownOptionId,
} from './activate-talkdown-popover.types';
export { ACTIVATE_TALKDOWN_OPTIONS } from './activate-talkdown-popover.types';

@Component({
  selector: 'eventq-activate-talkdown-popover',
  imports: [EventqDialogPopover, EventqActionableList],
  templateUrl: './activate-talkdown-popover.html',
  styleUrl: './activate-talkdown-popover.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventqActivateTalkdownPopover {
  readonly open = input(false);
  readonly title = input('Activate Talkdown');
  readonly closeLabel = input('Close');
  readonly activateLabel = input('Activate');
  readonly options = input<readonly ActivateTalkdownOption[]>(ACTIVATE_TALKDOWN_OPTIONS);
  readonly anchor = input<HTMLElement | null>(null);
  readonly placement = input<EventqDialogPopoverPlacement | 'auto'>('auto');
  readonly panelWidth = input<string | null>('420px');

  readonly closed = output<void>();
  readonly activate = output<ActivateTalkdownConfirm>();

  readonly listItems = computed((): EventqActionableListItem[] =>
    this.options().map((option) => ({
      id: option.id,
      labelLines: option.labelLines,
    })),
  );

  readonly resolvedPlacement = computed((): EventqDialogPopoverPlacement => {
    const placement = this.placement();
    if (placement !== 'auto') {
      return placement;
    }

    return this.anchor() ? 'anchor-top-end' : 'center';
  });

  onActivate(event: { id: string }): void {
    this.activate.emit({ optionId: event.id as ActivateTalkdownOptionId });
  }
}
